import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const createSchema = Yup.object().shape({
  cpf: Yup.string().required(mensagemPadrao),
  nome: Yup.string().required(mensagemPadrao),
  // email: Yup.string().required(mensagemPadrao),
  escolaridade: Yup.string().required(mensagemPadrao),
  profissao: Yup.string().required(mensagemPadrao)
  // aptidoes: Yup.string().required(mensagemPadrao)
})
